import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de un AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('petrolatina_token');
    if (token) {
      setUser({
        id: 1,
        nombre: 'Juan',
        apellido: 'Pérez',
        email: 'juan.perez@petrolatina.com.ar',
        rol: 'Gerente',
        avatar: null,
        permisos: ['rrhh', 'finanzas', 'administracion', 'operaciones']
      });
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (email && password) {
          const userData = {
            id: 1,
            nombre: 'Juan',
            apellido: 'Pérez',
            email: email,
            rol: 'Gerente',
            avatar: null,
            permisos: ['rrhh', 'finanzas', 'administracion', 'operaciones']
          };
          localStorage.setItem('petrolatina_token', 'demo_token_123');
          setUser(userData);
          resolve(userData);
        } else {
          reject(new Error('Credenciales inválidas'));
        }
      }, 1000);
    });
  };

  const logout = () => {
    localStorage.removeItem('petrolatina_token');
    setUser(null);
  };

  const hasPermission = (permission) => {
    return user?.permisos?.includes(permission) || false;
  };

  const value = {
    user,
    loading,
    login,
    logout,
    hasPermission,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
